import * as React from "react";

const MarleneMcneese = () => {
  return (
    <ol className="references">
      <li>
        Beima-Sofie K, Ortblad KF, Swanson F, Graham SM, Stekler JD, Simoni JM.
        “Keep it going if you can”: HIV service provision for priority
        populations during the COVID-19 pandemic in Seattle, WA.{" "}
        <i>AIDS Behav</i>. 2020;24(10):2760-2763.{" "}
        <a
          target="_blank"
          className="text-decoration-none"
          href="https://doi.org/10.1007/s10461-020-02902-5"
        >
          doi:10.1007/s10461-020-02902-5
        </a>
      </li>
      <li>
        Ennab F, Nawaz FA, Narain K, Nchasi G, Essar MY, Bin Rashid M. Rise of
        monkeypox: Lessons from COVID-19 pandemic to mitigate global health
        crises. <i>Ann Med Surg</i>. 2022;79:104049.
        doi:10.1016/j.amsu.2022.104049 <br class="desktop" />
      </li>
      <li>
        Stanford KA, Friedman EE, Schmitt J, et al. Routine screening for HIV in
        an urban emergency department during the COVID-19 pandemic.{" "}
        <i>AIDS Behav</i>. 2020;24:2757-2759. doi:10.1007/s10461-020-02899-x
        <br class="desktop" />
      </li>
      <li>
        National Liberty Museum website. La Brega. Accessed July 19, 2022.{" "}
        <a
          target="_blank"
          className=""
          href="https://www.libertymuseum.org/show-item/la-brega"
        >
          https://www.libertymuseum.org/show-item/la-brega
        </a>
      </li>
      <li>
        WNYC Studios website. What Is La Brega? Accessed July 19, 2022.{" "}
        <a
          target="_blank"
          className=""
          href="https://www.wnycstudios.org/podcasts/la-brega/articles/what-la-brega"
        >
          https://www.wnycstudios.org/podcasts/la-brega/articles/what-la-brega
        </a>
      </li>
      <li>
        Fauci AS & Lane HC. Four decades of HIV/AIDS — much accomplished, much
        to do. <i>N Engl J Med</i>. 2020;383(1):1-4. doi:10.1056/NEJMp1916753
      </li>
      <li>
        Kaiser Family Foundation website. The HIV/AIDS epidemic in the United
        States: the basics. Published June 7, 2021. Accessed August 31, 2022.{" "}
        <a
          target="_blank"
          className=""
          href="https://www.kff.org/hivaids/fact-sheet/the-hivaids-epidemic-in-the-united-states-the-basics/"
        >
          https://www.kff.org/hivaids/fact-sheet/the-hivaids-epidemic-in-the-united-states-the-basics/
        </a>
      </li>
      <li>
        Tomlinson H. CDC on the frontlines: transforming the global HIV epidemic
        in the midst of the COVID-19 pandemic. HIV.gov website. Published March
        9, 2022. Accessed June 27, 2022.{" "}
        <a
          target="_blank"
          className=""
          href="https://www.hiv.gov/blog/cdc-frontlines-transforming-global-hiv-epidemic-midst-covid-19-pandemic"
        >
          https://www.hiv.gov/blog/cdc-frontlines-transforming-global-hiv-epidemic-midst-covid-19-pandemic
        </a>
      </li>
    </ol>
  );
};

export default MarleneMcneese;
